import Cookies from 'js-cookie';

const TOKEN_KEY = 'impera_admin_token';

export const getToken = () => {
  return Cookies.get(TOKEN_KEY);
};

export const setToken = (token) => {
  // Set cookie with secure attributes for production/cross-domain support
  // Ensure secure: true only if https to avoid issues on localhost http
  const isSecure = window.location.protocol === 'https:';

  Cookies.set(TOKEN_KEY, token, {
    expires: 1, // 1 day
    secure: isSecure,
    sameSite: isSecure ? 'None' : 'Lax'
  });
  return true;
};

export const removeToken = () => {
  Cookies.remove(TOKEN_KEY);
  return true;
};

export const getAuthHeaders = () => {
  const token = getToken();
  if (!token) {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};

// Decode JWT token (basic decoding without verification - server will verify)
export const decodeToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

// Check if token is expired
export const isTokenExpired = (token) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) {
      return true;
    }
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    return true;
  }
};

